export function getVideoUrl(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url?.match(regExp)
  const res = `https://www.youtube.com/embed/${
    match && match[2].length === 11 ? match[2] : null
  }`

  return res
}
